<template>
  <div
    class="ib-list-view-placeholder-card-wrapper"
    :class="{'disabled': disabled}"
  >
    <div class="inner" :class="variant" />
  </div>
</template>

<script>
/** Colors **/
const COLORS = ['blue', 'yellow']

export default {
  name: 'IbListViewPlaceholderCard',

  props: {
    variant: {
      type: String,
      validator: value => {
        return COLORS.includes(value)
      },
      default: 'blue'
    },

    disabled: {
      type: Boolean,
      default: false
    }
  }
}
</script>

<style scoped lang="scss">
.ib-list-view-placeholder-card-wrapper {
  height: 60px;
  border-radius: 8px;
  opacity: 0.5;
  border: 1px solid rgba(84, 89, 113, 0.5);

  .inner {
    height: auto;
    min-height: 60px;
    margin: 0 10px;
    background-position: center;
    background-repeat: no-repeat;
    background-size: 100%;

    &.blue {
      background-image: asset("img/placeholders/placeholder-horizontal-blue.svg");
    }

    &.yellow {
      background-image: asset("img/placeholders/placeholder-horizontal-yellow.svg");
    }
  }

  &.disabled {
    cursor: not-allowed;
    filter: grayscale(0.7);
  }
}
</style>
